// This is the onboarding page for new employees

import { useState, useRef } from "react";
import { useAuth } from "../../App";
import { Divider, Error_Component, Header } from "../misc";
import { GenericForm, GenericInput } from "../GenericForm";
import { BottomFormButton } from "../Buttons";
import { OnBoardingFormData, OnBoardingFormProps } from "../../interfaces/onboarding_types";
import { postOnBoardingData } from "../../api/employee";
import { useNavigate } from "react-router-dom";

export default function OnBoarding() {
    const { user } = useAuth()
    if (!user) return <Error_Component errorString="User not found" />

    const navigate = useNavigate()

    const email_regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

    const [error, setError] = useState<string | null>(null)

    const employee_data = useRef<OnBoardingFormData>({
        name: user.name,
        email: user.email,
        password: "",
        confirm_password: ""
    })


    const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()

        setError(null)
        const formData = new FormData(e.target as HTMLFormElement)
        const data = Object.fromEntries(formData.entries())

        if (data.password !== data.confirm_password) {
            setError("Passwords do not match. Please try again.")
            return
        }

        if (!email_regex.test(data.email as string)) {
            setError("Invalid email address. Please enter a valid email address.")
            return
        }

        try {
            const response = await postOnBoardingData(data as OnBoardingFormData)
            if (response === 200) {
                navigate('/main_menu')
            } else {
                setError("Error submitting data. Please try again.")
            }
        } catch (error) {
            setError("Error submitting data. Please try again.")
            return
        }
    }

    return (
        <div className="h-screen grid grid-rows-[auto_1fr]">
            <Header remove_link />
            
            <div className="items-center w-screen mx-auto">
                {error && <Error_Component errorString={error} />}

                <div className="w-2/3 mx-auto p-6 my-4 border-2 rounded-lg shadow-md accent-dashboard-card dashboard-border">
                    <h1 className="text-2xl font-bold">Welcome!</h1>
                    <p className="mb-4">Please double check any information here to ensure it is correct and create a new password.</p>

                    <Divider />

                    <OnBoardingForm employee_data={employee_data.current} onSubmit={onSubmit}/>

                </div>
            </div>
        </div>
    )
}

function OnBoardingForm({ employee_data, onSubmit}: OnBoardingFormProps) {
    return (
        <GenericForm form_id="onboarding_form" onSubmit={onSubmit} className="mt-4 grid grid-cols-2 gap-4">
            <GenericInput label="Name" name="name" type="text" value={employee_data.name} />
            <GenericInput label="Email" name="email" type="email" value={employee_data.email} />
            <GenericInput label="Password" name="password" type="password" />
            <GenericInput label="Confirm Password" name="confirm_password" type="password" />

            <BottomFormButton button_text="Submit" className="col-span-2" hide_back_button />

        </GenericForm>
    )
}

// // This is the onboarding page for new employees

// import { useEffect, useState } from "react";
// import { useAuth } from "../../App";
// import { Divider, Error_Component, Header } from "../misc";
// import { GenericForm, GenericInput } from "../GenericForm";
// import { BottomFormButton } from "../Buttons";

// type OnBoardingFormData = {
//     name: string
//     email: string
//     password: string
//     confirm_password: string
// }

// export default function OnBoarding() {
//     const { user } = useAuth()
//     if (!user) return <Error_Component errorString="User not found" />

//     const [error, setError] = useState<string | null>(null)

//     const [employee_data, setEmployeeData] = useState<OnBoardingFormData>({
//         name: user.name,
//         email: user.email,
//         password: "",
//         confirm_password: ""
//     })

//     const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//         const { name, value } = e.target
//         setEmployeeData(prevData => ({ ...prevData, [name]: value }))
//     }

//     const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
//         e.preventDefault()

//         if (employee_data.password !== employee_data.confirm_password) {
//             setError("Passwords do not match")
//             return
//         }

//         setError(null)
//         //         const formData = new FormData(e.target as HTMLFormElement)
//         const data = Object.fromEntries(formData.entries())

//         //     }

//     return (
//         <div className="h-screen grid grid-rows-[auto_1fr]">
//             <Header remove_link />
            
//             <div className="items-center w-screen mx-auto">
//                 {error && <Error_Component errorString={error} />}

//                 <div className="bg-orange-50 w-2/3 mx-auto p-6 my-4 border-2 border-orange-200 rounded-lg shadow-md">
//                     <h1 className="text-2xl font-bold">Welcome!</h1>
//                     <p className="mb-4">Please double check your credentials and create a new password.</p>

//                     <Divider />

//                     <OnBoardingForm employee_data={employee_data} onSubmit={onSubmit} handleInputChange={handleInputChange} />

//                 </div>
//             </div>
//         </div>
//     )
// }

// type OnBoardingFormProps = {
//     employee_data: OnBoardingFormData
//     onSubmit: (e: React.FormEvent<HTMLFormElement>) => void
//     handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void
// }

// function OnBoardingForm({ employee_data, onSubmit, handleInputChange }: OnBoardingFormProps) {
//     return (
//         <GenericForm form_id="onboarding_form" onSubmit={onSubmit} className="mt-4 grid grid-cols-2 gap-4">
//             <GenericInput label="Name" name="name" type="text" value={employee_data.name} onChange={handleInputChange} />
//             <GenericInput label="Email" name="email" type="email" value={employee_data.email} onChange={handleInputChange} />
//             <GenericInput label="Password" name="password" type="password" onChange={handleInputChange} />
//             <GenericInput label="Confirm Password" name="confirm_password" type="password" onChange={handleInputChange} />

//             <BottomFormButton button_text="Submit" className="col-span-2" hide_back_button />

//         </GenericForm>
//     )
// }

